<a
	*ngIf="text; else missingInfo"
	class="group text-end w-fit text-sm rounded-md text-gray-500 flex items-center justify-center duration-300 ease-in-out px-2 gap-1 2xl:text-lg"
	(click)="redirect($event)"
	[href]="completedHref"
	[ngClass]="{
		'pr-0 hover:pr-2': hiddenIconOnBlur,
		'hover:bg-gray-100': backgroundColor === 'bg-white',
		'hover:bg-white': backgroundColor !== 'bg-white',
	}"
	[testHook]="testHooks.Link"
>
	<span>{{ text }}</span>
	<i-tabler
		class="w-4 h-4 min-h-4 min-w-4 opacity-0 group-hover:opacity-100 duration-100 ease-in-out"
		name="edit"
		[ngClass]="{
			'hidden group-hover:flex': hiddenIconOnBlur,
		}"
	/>
</a>

<ng-template #missingInfo>
	<app-missing-info-anchor [href]="completedHref" />
</ng-template>
